import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../../assets/images/logo.svg';
import { useAuth } from '../../hooks';
import VersionApp from '../version-app';
import { useAuth0 } from '@auth0/auth0-react';

const PNRNavPrimary = () => {
  const { logout } = useAuth0();
  const { logout: contextLogout } = useAuth();

  const handleLogout = () => {
    contextLogout();
    logout({ logoutParams: { returnTo: window.location.origin + '/' } });
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container fluid>
        <Navbar.Brand href="/">
          <img src={logo} alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto my-2 my-lg-0"></Nav>
          <Nav className="d-flex">
            <Nav.Link href="/">Validación PNR</Nav.Link>
          </Nav>
          <Nav className="d-flex">
            <Nav.Link
              as="button"
              type="button"
              className="border-start nav-link bg-transparent"
              onClick={handleLogout}
              style={{ cursor: 'pointer' }}
            >
              <span className="icon-logout me-2"></span>Cerrar Sesión
            </Nav.Link>
            <VersionApp isLogin={false} />
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default PNRNavPrimary;